import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button
} from '@lockerpm/design';

import common from '../../utils/common';

function Other() {
  const { t } = useTranslation();
  const plan = useSelector((state) => state.payment.plan)
  const userInfo = useSelector((state) => state.auth.userInfo)

  const [showAds, setShowAds] = useState(true)

  const isFree = useMemo(() => {
    return common.isFreePlan() && !common.isEnterpriseMember()
  }, [plan, userInfo])

  useEffect(() => {
    if (isFree && showAds) {
      setTimeout(() => {
        if (window.adsbygoogle) {
          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (e) {
            console.error('AdSense error:', e);
          }
        }
      }, 1000);
    }
  }, [isFree])

  return (
    <div className="admin-layout-other">
      {
        showAds && isFree && <div>
          <ins
            className="adsbygoogle h-full"
            style={{ display: 'block' }}
            data-ad-client={process.env.REACT_APP_ADS_CLIENT}
            data-ad-slot={process.env.REACT_APP_ADS_SLOT}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </div>
      }
      {
        showAds && isFree && <Button
          style={{
            position: 'absolute',
            top: -10,
            right: -10
          }}
          shape="round"
          size="small"
          danger
          onClick={() => setShowAds(false)}
        >
          {t('button.close')}
        </Button>
      }
    </div>
  );
}

export default Other;
